import { createSmileExpressionFrames } from "../../core/expression-keyframes.js";

export const meta = Object.freeze({
  id: "laugh",
  label: "Lachen",
  duration: 1600,
  description: "Lachaugen, zwei kleine Kicherer und ein weiches Nachfedern.",
  tags: ["expression", "one-shot", "loopable"],
});

export async function run({ elements, animate }) {
  const expression = createSmileExpressionFrames({
    enterStart: .09,
    enterCross: .13,
    enterEnd: .17,
    exitStart: .84,
    exitCross: .875,
    exitEnd: .91,
    settleEnd: .95,
    smileHoldFrames: [
      { opacity: 1, transform: "scale(.98, .94) translateY(1px)", offset: .38 },
      { opacity: 1, transform: "scale(1.04, 1.04) translateY(0)", offset: .54 },
      { opacity: 1, transform: "scale(1, 1) translateY(0)", offset: .78 },
    ],
  });

  const body = animate(elements.actor, [
    { transform: "translateY(0) scale(1, 1) rotate(0deg)", offset: 0 },
    { transform: "translateY(3px) scale(1.045, .955) rotate(0deg)", offset: .10, easing: "cubic-bezier(.35,0,.65,1)" },
    { transform: "translateY(-5px) scale(.985, 1.035) rotate(-2deg)", offset: .23, easing: "cubic-bezier(.2,.8,.3,1)" },
    { transform: "translateY(1px) scale(1.025, .98) rotate(2deg)", offset: .36 },
    { transform: "translateY(-4px) scale(.99, 1.025) rotate(-1.5deg)", offset: .49 },
    { transform: "translateY(1px) scale(1.018, .985) rotate(1.2deg)", offset: .62 },
    { transform: "translateY(-2px) scale(.997, 1.012) rotate(-.6deg)", offset: .74 },
    { transform: "translateY(0) scale(1, 1) rotate(0deg)", offset: 1, easing: "cubic-bezier(.16,1,.3,1)" },
  ], { duration: meta.duration, easing: "linear" });

  const openEyes = animate(elements.openEyes, expression.openEyes, {
    duration: meta.duration,
    easing: "linear",
  });

  const smileEyes = animate(elements.smileEyes, expression.smileEyes, {
    duration: meta.duration,
    easing: "linear",
  });

  const glow = animate(elements.glow, [
    { opacity: .48, offset: 0 },
    { opacity: .72, offset: .2 },
    { opacity: .62, offset: .58 },
    { opacity: .48, offset: 1 },
  ], { duration: meta.duration, easing: "ease-in-out" });

  await Promise.allSettled([body.finished, openEyes.finished, smileEyes.finished, glow.finished]);
}
